import { ModalProps } from "../../helpers/constants";
import React, { FC, useEffect, useState } from "react";
import Modal from "./form/Modal";
import InputField from "./form/InputField";
import { formatValueAsDateAndTime } from "../../helpers/utils/DateUtils";
import { useGetUserAuditableInfoQuery } from "../../features/user/users/usersApi";
import ButtonTray from "./form/ButtonTray";

interface props extends ModalProps {
    creationDate: string,
    createdBy: string,
    modifiedDate: string,
    modifiedBy: string
}

const AuditableInfoModal: FC<props> = ({ show, setShow, creationDate, createdBy, modifiedDate, modifiedBy }) => {
    let userIds = [];
    if (createdBy) {
        userIds.push(createdBy);
    }
    if (modifiedBy) {
        userIds.push(modifiedBy);
    }

    const auditableInfoApi = useGetUserAuditableInfoQuery({
        userIds: userIds
    });
    const [addBy, setAddedBy] = useState(createdBy);
    const [modifyBy, setModifyBy] = useState(modifiedBy);
    useEffect(() => {
        if (auditableInfoApi.data) {
            setAddedBy(auditableInfoApi?.data?.filter((el: any) => el.id === addBy)[0]?.username);
            setModifyBy(auditableInfoApi?.data?.filter((el: any) => el.id === modifyBy)[0]?.username);
        }
    }, [auditableInfoApi.data]);



    return (
        <> 
            <Modal
                title={"Auditable Info"}
                show={show}
                setShow={setShow}
                className={"w-2/6"}
                fields={
                    <>
                        <InputField
                            label="Created By"
                            value={addBy || "-"}
                            type="text"
                            disabled={true}
                        />

                        <InputField
                            label="Creation Date"
                            value={formatValueAsDateAndTime(creationDate) || ""}
                            type="text"
                            disabled={true}
                        />

                        <InputField
                            label="Modified By"
                            value={modifyBy || "-"}
                            type="text"
                            disabled={true}
                        />

                        <InputField
                            label="Modified Date"
                            value={formatValueAsDateAndTime(modifiedDate) || ""}
                            type="text"
                            disabled={true}
                        />
                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>

                        </div>
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Ok",
                                        onClick: () => setShow(false),
                                        type: "cancel",
                                    },
                                    buttonType: "button"
                                },
                            ]}
                        />
                    </>
                }
            />
        </>
    )
}
export default AuditableInfoModal;